import { atom } from "recoil";

import { ESupportedGames } from "../@types";
import { persistAtom } from ".";

export const UserGamePreference = atom<ESupportedGames>({
  key: "UserGamePreference_v0.1",
  default: ESupportedGames.CS2,
  effects_UNSTABLE: [persistAtom],
});

